import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Navi from '../views/Navi.vue';
import PdfViewer from '../views/PdfViewer.vue';
import { authState } from '@/store/modules/auth-state';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/navi',
    name: 'navi',
    component: Navi,
    meta: { requiresAuth: true },
  },
  {
    path: '/pdf/:pdfParams',
    name: 'pdf',
    component: PdfViewer,
    // meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !authState.loggedIn) {
    console.log('next redirect', to.fullPath);
    next({ path: '/', query: { redirect: to.fullPath } });
  } else {
    console.log('next');
    next();
  }
});

export default router;
